import React from 'react'
import Style from './OrderPerviewList.module.css'
import { separate } from '../../Seprate/Seprate'
const OrderPerviewList = ({data}) => {
  return (
    <ul className={Style.listHolder}>
        {data?.map((item,index)=>{
            return(
                <li key={index} className={Style.productHolder}>
                    <div className={Style.ProductDetail}>
                        <div className={Style.imgHolder}><img src={`//cdn.barest.ir/product/m/${item.product_id}.jpg`} alt="" /></div>
                        <div>
                            <p>{item.current_name}</p>
                            <p>تعداد: {item.count}</p>
                            </div>                        
                    </div>
                    <div><p style={{color:'green'}}>{separate(item.price)} تومان</p></div>
                </li>
            )
        })}
    </ul>
  )
}

export default OrderPerviewList